import type { AiBuilderChatState } from '../store/types';
import type {
  AiBuilderDifficultyHint,
  AiBuilderQuizTypeHint,
} from '../utils/types';

export const AI_BUILDER_CHAT_PLACEHOLDER = {
  default: 'default',
  softChoice: 'softChoice',
  closedAction: 'closedAction',
  file: 'file',
  youtube: 'youtube',
  website: 'website',
} as const;

export type AiBuilderChatPlaceholder =
  (typeof AI_BUILDER_CHAT_PLACEHOLDER)[keyof typeof AI_BUILDER_CHAT_PLACEHOLDER];

/**
 * 컴포저 "자세히 보기" 가이드 링크 fallback — 로케일이 stale 해서
 * learnMoreUrl 키가 원문 그대로 내려오면 상대경로 이동으로 깨지므로 방어한다.
 */
export const AI_BUILDER_GUIDE_FALLBACK_URL =
  'https://docs.channel.io/zepquiz/ko/articles/AI%EB%A1%9C-%EB%AC%B8%EC%A0%9C-%EC%B6%94%EA%B0%80-548d662c';

export const initialAiBuilderChatState: AiBuilderChatState = {
  panelOpen: false,
  conversationEntryIntent: null,
  conversationQuestionState: null,
  draft: '',
  placeholder: AI_BUILDER_CHAT_PLACEHOLDER.default,
  selectedFile: null,
  selectedQuizContext: null,
  sessionId: null,
  usage: null,
  sourceRefs: [],
  messages: [],
  isGenerating: false,
  turnInProgress: false,
};

export const initialAiBuilderComposerSignalState = {
  focusRequestId: 0,
  filePickerRequestId: 0,
  confirmActionAttentionRequestId: 0,
  confirmActionAttentionMessageId: null as string | null,
};

export const QUIZ_TYPE_HINT_BY_CHOICE_LABEL: Record<
  string,
  AiBuilderQuizTypeHint
> = {
  OX: 'ox',
  'OX 문제': 'ox',
  '선택형 문제': 'multiple',
  '단답형 문제': 'subjective',
  '서술형 문제': 'essay',
};

export const DIFFICULTY_HINT_BY_CHOICE_LABEL: Record<
  string,
  AiBuilderDifficultyHint
> = {
  쉬움: 1,
  보통: 2,
  어려움: 3,
};
